module.exports = __webpack_public_path__ + "img/terrain-icon-es.0e54b4ba.jpg";